import { useMemo, useCallback } from 'react';
import { useTheme } from 'styled-components';

import { StyledIcon, StyledTag, TextWrapper } from './CsatTag.styles';

import { EIconType } from '@/components/Icon';

type Props = {
  csat: number;
};

export const CsatTag: React.FC<Props> = ({ csat }) => {
  const { colors } = useTheme();
  const determineStyle = useCallback((): {
    color: string;
    backgroundColor: string;
    icon: EIconType;
  } => {
    if (csat >= 75) {
      return {
        color: colors.green6,
        backgroundColor: colors.green1,
        icon: 'FaceSatisfiedFilled'
      };
    }
    if (csat >= 50) {
      return {
        color: colors.orange6,
        backgroundColor: colors.orange1,
        icon: 'FaceNeutralFilled'
      };
    }
    return {
      color: colors.red6,
      backgroundColor: colors.red2,
      icon: 'FaceDissatisfiedFilled'
    };
  }, [csat, colors]);

  const { color, backgroundColor, icon } = useMemo(determineStyle, [determineStyle]);

  return (
    <StyledTag color={backgroundColor}>
      <StyledIcon backgroundColor={color} i={icon} />
      <TextWrapper color={color}>{`${csat.toFixed(2)}%`}</TextWrapper>
    </StyledTag>
  );
};
